import { createContext } from 'react';
import { ProposedFilingQuery } from './typings/Applications';

interface AppContextInterface {
    queryManagement: {
        queryTypes: string[]
        setQueryTypes: (value:string[]) => void,
        proposedQueryDetails: ProposedFilingQuery,
        setProposedQueryDetails: (value: ProposedFilingQuery) => void
    }
}

export const AppContext = createContext<AppContextInterface>({
    queryManagement: {
        queryTypes: [],
        setQueryTypes: (value: string[]) => [],
        proposedQueryDetails: {
            id: '',
            applicationId: '',
            applicationName: '',
            companyName: '',
            description: '',
            queryType: [],
            approvedBy: '',
            isApproved: false,
            dateCreated: '',
            dateUpdated: '',
            companyId: '',
            dateApproved: '',
            customerEmail: '',
            applicationQueryIds: [],
            applicationQueryCount: 0,
            approvedQueryTypes: []
        },
        setProposedQueryDetails: (value: ProposedFilingQuery) => []
    }
});
